import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';
import { StorageOfferResource } from 'app/storage-offer/storage-offer.resource';
import { ActivitiesService } from 'app/_services/activities.service';
import { useScrollToTop } from 'angular/utils/react';
import { getCognitoToken } from 'angular/utils/cognito';
import { config } from 'angular/utils/config';

(function () {
    'use strict';

    angular.module('app').controller('ActivitiesCtrl', ActivitiesCtrl);

    function ActivitiesCtrl(
        $log,
        $scope,
        Activity,
        activitiesService: ActivitiesService,
        auctionResource,
        platformSettingsService,
        ShipperUser,
        networkPointSearchService,
        $location,
        utilService,
        storageOfferResource: StorageOfferResource
    ) {
        var vm = this;

        vm.appBaseUrl = config.appBaseUrl;
        vm.showNewNotifications = false;

        vm.storageOfferResource = storageOfferResource;
        vm.uiLoading = {};
        vm.activityList = {};
        vm.filter = {
            state: activitiesService.FILTER_STATES_KEYS.ALL,
            categories: [],
            networkPoints: [],
            from: null,
            to: null
        };
        vm.filterData = {
            states: activitiesService.FILTER_STATES_KEYS,
            categories: activitiesService.FILTER_CATEGORY
        };
        vm.filterDataStorage = {
            states: activitiesService.FILTER_STATES_KEYS,
            categories: activitiesService.FILTER_CATEGORY_STORAGE
        };
        vm.recentActivitiesForCompany = null;
        vm.INPUT_ADDON = networkPointSearchService.INPUT_ADDON;
        vm.toggleAllCategories = toggleAllCategories;
        vm.submitSelectNetworkPoints = submitSelectNetworkPoints;
        vm.deleteBid = deleteBid;
        vm.deleteStorageBid = deleteStorageBid;
        vm.daysChunk = 1; // 1, 2 or 3 -> 30, 60 or 90 days
        vm.loadMore = loadMore;
        vm.showLoadMore = true;
        vm.showSlowFetchWarning = false;

        useScrollToTop();

        init();

        function init() {
            ShipperUser.getSettings({ setting: 'platform' }, function (res) {
                vm.recentActivitiesForCompany =
                    res.recentActivities === 'SHIPPER';
            });

            vm.showNewNotifications = true;

            fetchActivities();
        }

        function fetchActivities(merge = false) {
            if (merge) vm.uiLoading.showMore = true;
            else vm.uiLoading.activityList = true;

            if (merge) {
                vm.daysChunk = vm.daysChunk + 1;
                if (vm.daysChunk === 3) vm.showLoadMore = false;
            } else {
                vm.daysChunk = 1;
                vm.showLoadMore = true;
            }

            var isoFrom = vm.filter.from
                ? moment(vm.filter.from).toDate()
                : null;
            var isoTo = vm.filter.to ? moment(vm.filter.to).toDate() : null;

            // if to is set, but not from we explicitely set it to maximum
            if (vm.filter.to && !vm.filter.from)
                isoFrom = moment(new Date()).subtract(90, 'Days').toDate();

            // if neither to nor from are set we offer 30 days chunking
            if (!vm.filter.to && !vm.filter.from) {
                isoFrom = moment(new Date())
                    .subtract(30 * vm.daysChunk, 'Days')
                    .toDate();
                isoTo = moment(new Date())
                    .subtract(30 * (vm.daysChunk - 1), 'Days')
                    .toDate();
            }

            vm.showSlowFetchWarning = false;
            var timeoutId = setTimeout(() => {
                vm.showSlowFetchWarning = true;
            }, 10000);

            Activity.query(
                {
                    category: activitiesService.categoriesToFilter(
                        vm.filter.categories
                    ),
                    networkPoint: vm.filter.networkPoints,
                    from: isoFrom,
                    to: isoTo,
                    sortBy: 'lastActivity'
                },
                function (res) {
                    clearTimeout(timeoutId);
                    vm.showSlowFetchWarning = false;

                    const activityList = activitiesService.map(res.data);

                    if (vm.daysChunk === 1) {
                        vm.activityList = activityList;
                    } else {
                        const activities = [...vm.activityList.activities];

                        activityList.activities.forEach((newActivity) => {
                            if (
                                activities.find(
                                    (activity) =>
                                        activity.activityId ===
                                        newActivity.activityId
                                )
                            )
                                return;
                            // only add the new activity to the existing list, if it doesn't already exists there
                            // (this could happen if between rendering the activities and clicking "Load More..."
                            // more new activities come appear)
                            activities.push(newActivity);
                        });

                        vm.activityList.activities = activities;
                    }

                    // got empty list and haven't loaded all days? fetch more
                    if (
                        !vm.activityList.activities.length &&
                        vm.daysChunk !== 3
                    ) {
                        fetchActivities(true);
                    } else {
                        vm.uiLoading.activityList = false;
                        vm.uiLoading.showMore = false;
                    }
                },
                function () {
                    clearTimeout(timeoutId);
                    vm.showSlowFetchWarning = false;

                    vm.uiLoading.activityList = false;
                    vm.uiLoading.showMore = false;
                }
            );
        }

        function updateActivities() {
            if (!vm.uiLoading.activityList && !vm.uiLoading.showMore)
                fetchActivities();
        }

        $scope.$watch(() => vm.filter.categories, updateActivities, true);
        $scope.$watch(
            () => vm.filter.from,
            () => {
                vm.showLoadMore = !Boolean(vm.filter.from);
                updateActivities();
            },
            true
        );
        $scope.$watch(() => vm.filter.to, updateActivities, true);

        function toggleAllCategories() {
            if (vm.filter.allCategories && vm.filter.allCategoriesStorage) {
                vm.filter.categories = vm.filter.categories.concat(
                    utilService.values(vm.filterDataStorage.categories)
                );
            } else if (
                vm.filter.allCategories &&
                !vm.filter.allCategoriesStorage
            ) {
                vm.filter.categories = utilService.values(
                    vm.filterData.categories
                );
            } else if (
                !vm.filter.allCategories &&
                vm.filter.allCategoriesStorage
            ) {
                vm.filter.categories = utilService.values(
                    vm.filterDataStorage.categories
                );
            } else {
                vm.filter.categories = [];
            }
        }

        function loadMore() {
            fetchActivities(true);
        }

        function submitSelectNetworkPoints(selectedNetworkPoints) {
            vm.filter.networkPoints =
                platformSettingsService.extractIdsOfNetworkPoints(
                    selectedNetworkPoints
                );
            fetchActivities();
        }

        function deleteBid(index, bidId) {
            auctionResource.deleteBid(
                { id: bidId },
                function () {
                    delete vm.activityList.activities[index];
                    vm.uiDeleteBidSuccess = true;
                },
                function () {
                    vm.uiDeleteBidError = true;
                }
            );
        }

        function deleteStorageBid(index, bidId) {
            vm.storageOfferResource
                .deleteBid(
                    { id: bidId },
                    () => {
                        delete vm.activityList.activities[index];
                        vm.uiDeleteBidSuccess = true;
                    },
                    (err: any) => {
                        vm.uiDeleteBidError = true;
                    }
                )
                .$promise.finally(() => (this.deletionLoading = false));
        }
    }
})();
